import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Localizer from '../helpers/Localizer';

const Wrapper = styled.div` 
    position: absolute;
    right: 7px;
    z-index: 100;
    bottom: 22px;   


    .btn {
        box-shadow: 0 0 3px 0 rgba(0,0,0,.5);
        border-radius: 5px;
    }

    @media (max-width: 991px) { 
        top: 7px;
        bottom: auto; 
    }
    
`;

class MapCloseButton extends Component {

    static propTypes = {
        onClick: PropTypes.func.isRequired,
        width: PropTypes.number.isRequired
    };

    render() {

        const locale = document.getElementsByTagName('html')[0].getAttribute('lang');

        return (
            <Wrapper onClick={this.props.onClick}>
                <div className="btn btn-primary">

                    {this.props.width > 991 &&
                    <div><i className="fa fa-angle-double-up"/> &nbsp; {Localizer.translate('close map', locale)}</div>
                    }

                    {this.props.width <= 991 &&
                    <i className="fa fa-times"/>
                    }

                </div>
            </Wrapper>
        );
    };
}

export default MapCloseButton;